module.exports = __webpack_public_path__ + "static/media/YF07_5.6f30e577.jpg";